import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Supplier } from '../_interfaces/supplier';

// Backed by /suppliers/* - see suppliers.controller.ts / suppliers.service.ts
// in nustone-backend.
@Injectable({
  providedIn: 'root',
})
export class SupplierService {
  constructor(private http: HttpClient) {}

  getSuppliers(search?: string): Observable<Supplier[]> {
    return this.http.get<Supplier[]>('/suppliers', { params: search ? { search } : {} });
  }

  getSupplierById(id: number): Observable<Supplier> {
    return this.http.get<Supplier>(`/suppliers/${id}`);
  }

  createSupplier(input: Partial<Supplier>): Observable<Supplier> {
    return this.http.post<Supplier>('/suppliers', input);
  }

  updateSupplier(id: number, input: Partial<Supplier>): Observable<{ success: boolean }> {
    return this.http.put<{ success: boolean }>(`/suppliers/${id}`, input);
  }
}
